import { Component, OnInit, EventEmitter, ComponentFactoryResolver } from '@angular/core';
import { Subject } from 'rxjs';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
// Modules
import { BroadcastEventModel, BroadcastService, GridBaseComponent, ModalService, ModalSize } from '@cv-invision/core';
// Service
import { SoftwareCollectorPackagesService } from '../service/software-collector-packages.service';
// Model
import { SoftwareCollectorPackagesColumnsModel } from './model/software-collector-packages-column.model';
import { AssignToList } from './model/software-collector-packages.model';
// Other
import { CustomActionSoftwareCollectorPackageCellComponent } from './custom-grid-cell/custom-action-software-collector-package-cell.component';
import { CreateUpdatePackageComponent } from './create-update-package/create-update-package.component';

export const UPDATE_INSIDE_MAPS_LIST = 'UPDATE_INSIDE_MAPS_LIST';

@Component({
	selector: 'cv-software-collector-packages',
	templateUrl: './software-collector-packages.component.html',
	styleUrls: ['./software-collector-packages.component.scss']
})
export class SoftwareCollectorPackagesComponent extends GridBaseComponent implements OnInit {
	packageListTmp: Array<any>;
	private atComponentDestroy: Subject<any> = new Subject<any>();
	private searchTextChange: EventEmitter<any> = new EventEmitter<any>();

	constructor(
		private softwareCollectorService: SoftwareCollectorPackagesService,
		private broadcastService: BroadcastService,
		private componentFactoryResolver: ComponentFactoryResolver,
		private modalService: ModalService
	) {
		super();
	}

	ngOnInit(): void {
		this.gridOptions.columnDefs = new SoftwareCollectorPackagesColumnsModel().columns;
		this.gridOptions.frameworkComponents = {
			CustomActionSoftwareCollectorPackageCellComponent: CustomActionSoftwareCollectorPackageCellComponent
		};
		this.searchTextChange
			.pipe(
				distinctUntilChanged()
			)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe((event: any) => {
				if (event.property === 'title') {
					// eslint-disable-next-line no-useless-escape
					const title = event.value.replace(/[&\/\\#,+()$~%'":*?<>{}]/g, '') || '';
					const result = this.packageListTmp.filter(packageItem => packageItem.title.toLowerCase().indexOf(title.toLowerCase()) !== -1);
					this.gridData = result;
				}
			});
		this.loadGridData();
		this.registerRefreshListListener();
		this.softwareCollectorService
			.getReloadListConfirmationListener()
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(result => {
				if (result && result.reloadList) {
					this.loadGridData();
				}
			});
	}

	/**
	 *  Call service endpoint to search Inside Maps.
	 */
	loadGridData(): void {
		this.softwareCollectorService.getPackages()
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(
			result => {
				if (result.length) {
					const packageList = result.map(packageItem => {
						const assignedTo = AssignToList.filter(
							assignTo => assignTo.id === packageItem.assignedTo
						);
						if (assignedTo.length) {
							packageItem.assignedTo = assignedTo[0].name;
						}
						return packageItem;
					});
					this.gridData = packageList;
					this.packageListTmp = packageList;
				}
			},
			error => console.error(error)
		);
	}

	/**
	 * Filter List By Title
	 */
	onSearchTextChange(property: string, event: any): void {
		this.searchTextChange.emit({ property: property, value: event.value });
	}

	/**
	 * Register Lister to refresh inside maps list
	 */
	private registerRefreshListListener(): void {
		this.broadcastService
			.onEvent(UPDATE_INSIDE_MAPS_LIST)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe((e: BroadcastEventModel) => {
				this.loadGridData();
			});
	}

	/***
	 * add new Inside Maps
	 */
	onAddPackage(): void {
		this.modalService
			.open({
				componentFactoryResolver: this.componentFactoryResolver,
				component: CreateUpdatePackageComponent,
				data: {},
				modalConfiguration: {
					title: 'New Package Configuration',
					modalSize: ModalSize.XL,
				},
			})
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe((result) => {
				if (result.success) {
					this.loadGridData();
				} else {
					// it failed :(
				}
			});
	}
}
